import { ThunkDispatch } from 'redux-thunk';
import { isAPIFailed, isAPISuccess } from '../../../utils/Util';
import {
  getWelcomeVideosList,
  removeMedia,
  uploadMedia,
} from '../../../features/welcomeVideosSlice';
import {
  CLICK_ACTIONS,
  maxFilesInAdminSettings,
} from '../../../utils/Constant';

export const defaultData = {
  title: '',
  order: '',
  thumbnail: undefined,
  media: undefined,
};

export const getWelcomeVideos = (dispatch: ThunkDispatch<any, any, any>) => {
  dispatch(getWelcomeVideosList());
};

export const handleUploadFile = (
  data: any,
  setData: (params: any) => void,
  options: {
    setShowLoader: (param: any) => void;
    dispatch: ThunkDispatch<any, any, any>;
    toast: any;
  }
) => {
  const payload = new FormData();
  const { setShowLoader, dispatch, toast } = options;
  const { title, order, thumbnail = '', media = '' } = data;
  payload.append('bannerTitle', title);
  payload.append('bannerOrder', order);
  payload.append('bannerThumbnail', thumbnail);
  payload.append('mediaFile', media);
  setShowLoader(true);
  dispatch(uploadMedia(payload))
    .then((fulfilled: any) => {
      setShowLoader(false);
      if (isAPISuccess(fulfilled.payload)) {
        toast.success(fulfilled.payload.responseInformation.responseMessage);
        getWelcomeVideos(dispatch);
        setData(defaultData);
      } else if (isAPIFailed(fulfilled)) {
        toast.error(fulfilled.responseInformation.responseMessage);
      }
    })
    .catch(() => {
      setShowLoader(false);
      toast.error('Media Upload Failed');
    });
};

export const handleSubmit = (
  data: any,
  setData: (params: any) => void,
  options: {
    setShowLoader: (param: any) => void;
    dispatch: ThunkDispatch<any, any, any>;
    toast: any;
  }
) => {
  let valid = true;
  const { setShowLoader, dispatch, toast } = options;
  if (!data.title) {
    toast.error('Title is required');
    valid = false;
  } else if (!data.order) {
    toast.error('Order is required');
    valid = false;
  } else if (
    Number(data.order) < 1 ||
    Number(data.order) > maxFilesInAdminSettings.welcomeVideos
  ) {
    toast.error(
      `Order should be between 1 and ${maxFilesInAdminSettings.welcomeVideos}`
    );
    valid = false;
  } else if (!data.thumbnail) {
    toast.error('Thumbnail is required');
    valid = false;
  } else if (!data.media) {
    toast.error('Media is required');
    valid = false;
  }
  if (valid) {
    handleUploadFile(data, setData, { setShowLoader, dispatch, toast });
  }
};

export const onRemove = (
  id: number | string,
  setShowAlertPopUp: (params: any) => void,
  setRemoveMediaId: (params: any) => void
) => {
  setShowAlertPopUp(true);
  setRemoveMediaId(id);
};

export const handleRemove = (
  removeMediaId: any,
  setShowLoader: (param: any) => void,
  dispatch: ThunkDispatch<any, any, any>,
  toast: any
) => {
  if (removeMediaId) {
    setShowLoader(true);
    dispatch(removeMedia({ id: removeMediaId }))
      .then((fulfilled: any) => {
        setShowLoader(false);
        if (isAPISuccess(fulfilled.payload)) {
          toast.success(fulfilled.payload.responseInformation.responseMessage);
          getWelcomeVideos(dispatch);
        } else if (isAPIFailed(fulfilled.payload)) {
          toast.error(fulfilled.payload.responseInformation.responseMessage);
        }
      })
      .catch(() => {});
  }
};

export const alertPopupToggle = (
  action: string,
  options: {
    removeMediaId: any;
    setShowLoader: (param: any) => void;
    dispatch: ThunkDispatch<any, any, any>;
    toast: any;
  },
  setShowAlertPopUp: (param: any) => void,
  setRemoveMediaId: (param: any) => void
) => {
  const { removeMediaId, setShowLoader, dispatch, toast } = options;
  if (action === CLICK_ACTIONS.APPROVE) {
    handleRemove(removeMediaId, setShowLoader, dispatch, toast);
  }
  setShowAlertPopUp(false);
  setRemoveMediaId(null);
};
